/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：C38k
 */

"use strict"

/* harmony export (binding) */
export { zh_CN }
var zh_CN = {
  "work/project_title": "我的作品"
}

/***/
